import { PromotionService } from '../services/PromotionService'
import { usePromotionStore } from '../store'

export const usePromotionModule = () => {
  const alt = useAlt()

  return {
    get service() {
      return alt.get(PromotionService)
    },
    get store() {
      return usePromotionStore()
    },
  }
}
